import BlockModal from "components/pages/schedule/styles/BlockModal";
import useDowntimeShowModal from "hooks/state/useDowntimeShowModal";
import React from "react";
import ReadOnlyDowntimeBlock from "./ReadOnlyDowntimeBlock";

export default function ReadOnlyDowntimeBlockModal() {
  const { block: blockData, isOpen, close } = useDowntimeShowModal();

  return (
    <BlockModal className="spec-block-modal" isOpen={isOpen} onRequestClose={close} title="Downtime block">
      {blockData && <ReadOnlyDowntimeBlock blockData={blockData} onClose={close} />}
    </BlockModal>
  );
}
